import {useCallback, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectUsedPremiumFeature} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';
import {selectIsPremium} from '~/CreateFabricInvitation/reducers/fabricTemplate/selectors';
import {selectEventId} from '~/common/fabric/EventGuests/reducers/guests/selectors';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';
import {selectEventStatus} from '~/common/fabric/reducers/eviteEvent/selectors';
import {UPDATE_DESIGN_OPTIONS} from '~/common/fabric/reducers/fabricDesign/constants';
import {EVENT_STATUS_DRAFT} from '~/common/utils/event_constants';
import {sendUpsellTrack, trackUpsell} from '~/common/utils/upsellTracking';
import {selectShowMatchingSetPreview} from '~/OneStepCreateInvitation/reducers/fabricDesign/selectors';
import {toastAlert} from '~library/atoms/Toast';
import {Typography} from '~library/atoms/Typography';

const isInvitationMaker = window.location.pathname.startsWith('/invitation-maker');

export const showPremiumUpgradeSuccessToast = () =>
  toastAlert(
    <Typography as="span" variant="paragraph2">
      <strong>🎉 Your Invitation is now Premium!</strong>
      <br />
      More features are unlocked. Welcome to the good life!
    </Typography>,
    {
      type: 'success',
      icon: null,
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      useLightStyle: true,
    }
  );

export const usePremiumFeatureBlocker = () => {
  const dispatch = useDispatch();
  const [shouldShowModal, setShouldShowModal] = useState(false);
  const usedPremiumFeature = useSelector(selectUsedPremiumFeature);
  const isPremium = useSelector(selectIsPremium);
  const eventId = useSelector(selectEventId);
  const status = useSelector(selectEventStatus);
  const showMatchingSetPreview = useSelector(selectShowMatchingSetPreview);
  const isUsingPremiumFeature = !isPremium && usedPremiumFeature;

  const onBlockedElementClick = useCallback(() => {
    if (!shouldShowModal) {
      setShouldShowModal(true);
    }
  }, [shouldShowModal]);

  const dismissModal = useCallback(() => setShouldShowModal(false), []);

  const confirmUpgrade = useCallback(() => {
    trackUpsell({
      path: isInvitationMaker
        ? 'invitation-maker'
        : window.location.pathname?.replace(/\/$/, '')?.split('/')?.at(-1),
      feature: 'design-tools',
      status: status || EVENT_STATUS_DRAFT,
    });
    if (eventId) {
      sendUpsellTrack(eventId);
    }
    dispatch({
      type: UPDATE_EVENT_DETAILS,
      payload: {isPremium: true, hideUpsell: true},
    });
    if (showMatchingSetPreview) {
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {showMatchingSetPreview: false},
      });
    }
    showPremiumUpgradeSuccessToast();
  }, [dispatch, eventId, showMatchingSetPreview, status]);

  return {
    isUsingPremiumFeature,
    shouldShowModal,
    dismissModal,
    onBlockedElementClick,
    confirmUpgrade,
  };
};
